export default __webpack_public_path__ + "static/media/government-of-umm-alquwain.e88fb44e.png";